export const environment = {
  production: true,
  api: {
    root: 'https://icrrappel.myinforius.be/back/api/v1',
  },
};
